export const SPECIALIST_DRAWER_ID = 'specialist-drawer'
